import { useTabsItems } from '../hooks';
import { Tabs } from '../../../../common/components';
import { ManualDeliveryDialog } from '../components/toReceiveCrossdocking';
import { BarcodeScannerModal } from '../components/BarcodeScanner';
import {
  useCrossdockingContext,
  useToReceiveCrossdockingActions,
} from '../../application/hooks';

export default function ToReceiveCrossdockingView() {
  const {
    openManualReceiving,
    setOpenManualReceiving,
    openBarcodeScanner,
    setOpenBarcodeScanner,
  } = useCrossdockingContext();

  const tabsItems = useTabsItems({ setOpenBarcodeScanner });

  const {
    onCodeScanned,
    onManualDelivery,
    isLoadingToReceiveCrossdockingFromWarecloud,
  } = useToReceiveCrossdockingActions();

  return (
    <>
      <Tabs tabsItems={tabsItems} />

      {openManualReceiving && (
        <ManualDeliveryDialog
          onClose={() => {
            setOpenManualReceiving(false);
          }}
          onManualDelivery={onManualDelivery}
          isLoading={isLoadingToReceiveCrossdockingFromWarecloud}
        />
      )}

      {openBarcodeScanner && (
        <BarcodeScannerModal
          open={openBarcodeScanner}
          onClose={() => setOpenBarcodeScanner(false)}
          onCodeScanned={onCodeScanned}
          processing={isLoadingToReceiveCrossdockingFromWarecloud}
        />
      )}
    </>
  );
}
